import { render, staticRenderFns } from "./SeverityFilter.vue?vue&type=template&id=44fa8556"
import script from "./SeverityFilter.vue?vue&type=script&lang=js"
export * from "./SeverityFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports